import React from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as user from "../../utils/user.js";
import * as navigation from "../../utils/navigation.js";

const Logout = (props) => {
  const handleLogout = async (e) => {
    const success = await user.logout();
    if (success) {
      navigation.changePage("login"); // Redirect to login page after logout
    }
  };

  return (
    <div
      style={{
        ...props.style,
        backgroundColor: "#2c2c2c", // Darker background for consistency with Login component
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Darker shadow for depth
        alignItems: "center",
        justifyContent: "center", // Ensure content is centered
        padding: "20px", // Padding inside the container
      }}
    >
      <button
        style={{
          margin: "10px 0",
          padding: "10px",
          width: "100%", // Full width button
          maxWidth: "500px", // Consistent width with Login component
          backgroundColor: "#007bff", // Button color consistent with Login component
          color: "#fff", // White text for contrast
          border: "none",
          borderRadius: "5px", // Rounded corners
          cursor: "pointer",
          fontSize: "16px",
          transition: "background-color 0.3s ease", // Smooth hover transition
        }}
        onClick={handleLogout}
      >
        Logout
      </button>
    </div>
  );
};

export default Logout;
